import {OptOutPPC} from '../../constants';
import {Features} from './types';

const mapShowArhiPPCInformation = (showArhiPPCInformation: boolean) => (OptOutPPC ? false : showArhiPPCInformation);

export const mapFeatureToggles = (features: Features) => ({
  ...features,
  showArhiPPCInformation: mapShowArhiPPCInformation(features.showArhiPPCInformation)
});
